import http from '@/util/http';

export default {
	getBillAddressInfo() {
		return http.get('ChangeBillAddress/api/getBillAddressInfo');
	},
	changeBillAddress(payload) {
		return http.post('ChangeBillAddress/api/changeBillAddress', payload);
	},
}


// WEBPACK FOOTER //
// ./src/api/changeBillAddress/changeBillAddressApi.js